import * as React from 'react';
import moment from 'moment';

import { usePerDiemParams } from 'pages/PerDiemArchive/params';
import { DateSelector } from 'components/Selectors';

interface StartDateSelectorProps {
  minDate?: moment.Moment;
}

export const StartDateSelector: React.FC<StartDateSelectorProps> = (props) => {
  const { minDate } = props;

  const { searchParams, setSearchParams } = usePerDiemParams();

  return (
    <DateSelector
      label="Start Date"
      value={searchParams.startDate}
      onChange={(startDate) => setSearchParams({ startDate })}
      minDate={minDate}
      maxDate={moment().startOf('day')}
      errorMessage={`Invalid date; Dates must be entered in mm/dd/yyyy format and occur later than ${minDate?.format(
        'MM/DD/yyyy'
      )}.`}
    />
  );
};
